import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Grid, Typography, Box, IconButton,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, CircularProgress, Backdrop, TextField,
} from '@mui/material';
import { Close } from '@mui/icons-material';

const fieldStyle = {
  '& .MuiInputBase-root': { fontSize: '12px', height: '32px', bgcolor: '#f9fafb' },
  '& .MuiInputLabel-root': { fontSize: '12px' },
};

const DebitNoteModal = ({
  open,
  onClose,
  modalAction,
  formData,
  setFormData,
  noteDetails,
  setNoteDetails,
  onSave,
  loading,
  companyId,
  branchId,
  token,
}) => {
  const isView = modalAction === 'view';
  const title  = isView ? 'View Debit Note' : 'Edit Debit Note';

  const handleChange = (field, value) => {
    if (isView) return;
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const billNo = [
    formData.BillPrefix,
    formData.BillNumber,
    formData.FinYear,
  ].filter(Boolean).join('/');

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        background: 'linear-gradient(135deg, #2C3E6E, #3a5298)', color: 'white',
        py: 1.5, px: 2, fontSize: '15px', fontWeight: 700, fontFamily: 'Times New Roman',
      }}>
        {title}
        <IconButton onClick={onClose} size="small" sx={{ color: 'white' }}>
          <Close fontSize="small" />
        </IconButton>
      </DialogTitle>

      <Backdrop open={loading} sx={{ zIndex: 9999, color: '#fff' }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <DialogContent sx={{ p: 2, fontFamily: 'Times New Roman' }}>
        {/* Header Info */}
        <Box sx={{ mb: 2, p: 1.5, bgcolor: '#f0f4ff', borderRadius: 2, border: '1px solid #c7d7f5' }}>
          <Grid container spacing={1.5}>
            <Grid item xs={6} sm={3}>
              <TextField fullWidth size="small" label="Bill No" value={billNo || '-'} disabled sx={fieldStyle} />
            </Grid>
            <Grid item xs={6} sm={3}>
              <TextField fullWidth size="small" label="Bill Date" value={formData.BillDate || '-'} disabled={isView}
                onChange={e => handleChange('BillDate', e.target.value)} sx={fieldStyle} />
            </Grid>
            <Grid item xs={6} sm={3}>
              <TextField fullWidth size="small" label="Vendor" value={formData.VendorName || formData.MasterName || formData.CustomerName || '-'} disabled sx={fieldStyle} />
            </Grid>
            <Grid item xs={6} sm={3}>
              <TextField fullWidth size="small" label="GST No" value={formData.GSTNumber || '-'} disabled sx={fieldStyle} />
            </Grid>
            <Grid item xs={6} sm={3}>
              <TextField fullWidth size="small" label="Ref Bill No" value={formData.RefBillNo || formData.RefBillNumber || '-'} disabled sx={fieldStyle} />
            </Grid>
            <Grid item xs={6} sm={3}>
              <TextField fullWidth size="small" label="Remarks" value={formData.Remarks || '-'} disabled={isView}
                onChange={e => handleChange('Remarks', e.target.value)} sx={fieldStyle} />
            </Grid>
          </Grid>
        </Box>

        {/* Items Table */}
        <Typography sx={{ fontSize: '13px', fontWeight: 700, mb: 1, color: '#2C3E6E' }}>Items</Typography>
        <TableContainer component={Paper} sx={{ boxShadow: 'none', border: '1px solid #e5e7eb', borderRadius: 2, mb: 2 }}>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ background: '#2C3E6E' }}>
                {['#', 'Item', 'HSN', 'Qty', 'Rate', 'GST%', 'Taxable', 'CGST', 'SGST', 'IGST', 'Total'].map((h, i) => (
                  <TableCell key={i} sx={{ color: 'white', fontSize: '11px', fontWeight: 600, py: 0.8, px: 1,
                    textAlign: i >= 3 ? 'right' : 'left' }}>{h}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {noteDetails.length > 0 ? noteDetails.map((d, i) => (
                <TableRow key={i} sx={{ bgcolor: i % 2 === 0 ? '#fff' : '#f8f9fa' }}>
                  <TableCell sx={{ fontSize: '11px', py: 0.8, px: 1 }}>{i + 1}</TableCell>
                  <TableCell sx={{ fontSize: '11px', py: 0.8, px: 1 }}>{d.ItemName || '-'}</TableCell>
                  <TableCell sx={{ fontSize: '11px', py: 0.8, px: 1 }}>{d.HSNCode || '-'}</TableCell>
                  <TableCell sx={{ fontSize: '11px', py: 0.8, px: 1, textAlign: 'right' }}>{Number(d.Quantity || 0).toFixed(2)}</TableCell>
                  <TableCell sx={{ fontSize: '11px', py: 0.8, px: 1, textAlign: 'right' }}>{Number(d.Rate || 0).toFixed(2)}</TableCell>
                  <TableCell sx={{ fontSize: '11px', py: 0.8, px: 1, textAlign: 'right' }}>{d.GSTRate ? `${d.GSTRate}%` : '0%'}</TableCell>
                  <TableCell sx={{ fontSize: '11px', py: 0.8, px: 1, textAlign: 'right' }}>{Number(d.TaxableAmount || 0).toFixed(2)}</TableCell>
                  <TableCell sx={{ fontSize: '11px', py: 0.8, px: 1, textAlign: 'right' }}>{Number(d.CGSTAmount || 0).toFixed(2)}</TableCell>
                  <TableCell sx={{ fontSize: '11px', py: 0.8, px: 1, textAlign: 'right' }}>{Number(d.SGSTAmount || 0).toFixed(2)}</TableCell>
                  <TableCell sx={{ fontSize: '11px', py: 0.8, px: 1, textAlign: 'right' }}>{Number(d.IGSTAmount || 0).toFixed(2)}</TableCell>
                  <TableCell sx={{ fontSize: '11px', py: 0.8, px: 1, textAlign: 'right', fontWeight: 700 }}>{Number(d.TotalAmount || 0).toFixed(2)}</TableCell>
                </TableRow>
              )) : (
                <TableRow>
                  <TableCell colSpan={11} sx={{ textAlign: 'center', py: 2, color: '#6b7280', fontSize: '12px' }}>
                    No items found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Summary */}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Box sx={{ width: 260, border: '1px solid #c7d7f5', borderRadius: 2, overflow: 'hidden' }}>
            {[
              ['Subtotal',    formData.Amount],
              ['CGST',        formData.CGSTAmount],
              ['SGST',        formData.SGSTAmount],
              ['IGST',        formData.IGSTAmount],
              ['Discount',    formData.DiscountAmount],
              ['Round Off',   formData.RoundOff],
            ].filter(([, v]) => parseFloat(v || 0) !== 0).map(([label, val], i) => (
              <Box key={i} sx={{ display: 'flex', justifyContent: 'space-between', px: 1.5, py: 0.5, bgcolor: i % 2 === 0 ? '#f8f9fa' : '#fff' }}>
                <Typography sx={{ fontSize: '12px', color: '#374151' }}>{label}:</Typography>
                <Typography sx={{ fontSize: '12px', color: '#374151' }}>₹{Number(val || 0).toFixed(2)}</Typography>
              </Box>
            ))}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', px: 1.5, py: 1, bgcolor: '#2C3E6E' }}>
              <Typography sx={{ fontSize: '13px', fontWeight: 700, color: 'white' }}>Grand Total:</Typography>
              <Typography sx={{ fontSize: '13px', fontWeight: 700, color: 'white' }}>
                ₹{Number(formData.TotalAmount || formData.GrandTotal || 0).toFixed(2)}
              </Typography>
            </Box>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 2, py: 1.5, borderTop: '1px solid #f0f0f0' }}>
        {!isView && (
          <Button onClick={onSave} variant="contained"
            sx={{ textTransform: 'none', background: '#2C3E6E', fontSize: '13px' }}>
            Save
          </Button>
        )}
        <Button onClick={onClose} variant="outlined"
          sx={{ textTransform: 'none', fontSize: '13px' }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DebitNoteModal;

